<template>
    <div class="uncompleted-tags">
        <CategoriesTag @handleClick="removeCategoryTag" />
        <LevelTag @handleClick="removeTag('level')" />
        <InstructorTag @handleClick="removeTag('instructor')" />
        <AuthorizationTag @handleClick="removeTag('authorization')" />
        <ContentTypeTag @handleClick="removeTag('contentType')" />
    </div>
</template>

<script>
    import CategoriesTag from 'components/user/items-listings/tags/CategoriesTag'
    import LevelTag from 'components/user/items-listings/tags/LevelTag'
    import InstructorTag from 'components/user/items-listings/tags/InstructorTag'
    import AuthorizationTag from 'components/user/items-listings/tags/AuthorizationTag'
    import ContentTypeTag from '../items-listings/tags/ContentTypeTag.vue'

    export default {
        components: {
            CategoriesTag,
            LevelTag,
            InstructorTag,
            AuthorizationTag,
            ContentTypeTag
},
        methods: {
            removeTag (option) {
                this.$emit('removeTag', option)
            },
            removeCategoryTag (option) {
                this.$store.dispatch('CourseFilter/removeSelectedOption', option)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .uncompleted-tags {
        display: flex;
        flex-wrap: wrap;
    }
</style>
